import Link from 'next/link';
import { getCommunityProfilePageUrl } from 'lib/community';
import { useContext } from 'react';
import { UserContext } from 'contexts/user';
import { useRouter } from 'next/router';
import { insertIf, join } from 'lib/helpers';
import styles from './AccountNav.module.css';
import { DropdownChevron } from 'components/common/svgIcons';

type Props = {
  teamId?: number;
};

const AccountNav = ({ teamId }: Props) => {
  const router = useRouter();
  const { user } = useContext(UserContext);
  if (user === undefined) {
    return null;
  }
  const teamLabel = 'Workspaces';
  return (
    <div className={styles.NavContainer}>
      <AccountNavButton
        label="Account"
        href="/account"
        isActive={
          !teamId &&
          ![
            '/account/teams',
            '/account/notifications',
            '/account/links',
          ].includes(router.pathname)
        }
      />
      <AccountNavButton
        label={teamLabel}
        href="/account/teams"
        isActive={teamId != null || router.pathname === '/account/teams'}
      />
      {user.username && (
        <AccountNavButton
          label="Profile"
          href={getCommunityProfilePageUrl(user.username)}
        />
      )}
      <AccountNavButton label="Notifications" href="/account/notifications" />
      <AccountNavButton label="Share Links" href="/account/links" />
    </div>
  );
};

export default AccountNav;

type NavButtonProps = {
  label: string;
  href: string;
  isActive?: boolean;
  teamName?: string;
};

const AccountNavButton = ({
  label,
  href,
  isActive,
  teamName,
}: NavButtonProps) => {
  const router = useRouter();
  const shouldShowActive = (): boolean => isActive ?? router.pathname === href;

  return (
    <Link href={href}>
      <a
        className={join([
          styles.NavButton,
          ...insertIf(shouldShowActive(), styles.NavButtonActive),
        ])}
      >
        {label}
        {teamName && (
          <>
            <div className={styles.SubNavArrow}>
              <DropdownChevron />
            </div>
            {teamName}
          </>
        )}
      </a>
    </Link>
  );
};
